import Period from "./Period";
import DateElements from "./DateElements";
import Tenor from "./Tenor";
class Maturity {
    date;
    nonCall;
    perpetual;
    scheduledDissolutionDate;
    tenor;
    weightedAverageLife;
    constructor(response) {
        this.date = response.date !== undefined ? new DateElements(response.date) : undefined;
        this.nonCall = response.nonCall !== undefined ? new Period(response.nonCall) : undefined;
        this.perpetual = response.perpetual;
        this.scheduledDissolutionDate = response.scheduledDissolutionDate;
        this.tenor = response.tenor !== undefined ? new Tenor(response.tenor) : undefined;
        this.weightedAverageLife = response.weightedAverageLife !== undefined ? new Period(response.weightedAverageLife) : undefined;
    }
    print() {
        if (this.scheduledDissolutionDate !== undefined) {
            const dateRegex = /(?<year>[0-9]{4})(-(?<month>[0-9]{2})(-(?<day>[0-9]{2}))?)?/;
            const dateMatchArray = dateRegex.exec(this.scheduledDissolutionDate);
            const groups = dateMatchArray?.groups;
            if (groups !== undefined) {
                const { year } = groups;
                const month = 'month' in groups ? groups.month : undefined;
                const day = 'day' in groups ? groups.day : undefined;
                const yearValue = parseInt(year, 10);
                const monthValue = month !== undefined ? parseInt(month, 10) : 0;
                const dayValue = day !== undefined ? parseInt(day, 10) : 1;
                const realDate = new Date(Date.UTC(yearValue, monthValue - 1, dayValue));
                let precision = 'Y';
                if (month !== undefined)
                    precision = 'YM';
                if (day !== undefined)
                    precision = 'YMD';
                return { value: realDate, options: { precision } };
            }
        }
        if (this.date !== undefined) {
            return this.date.print();
        }
        if (this.perpetual || this.tenor?.perpetual) {
            return 'Perpetual';
        }
        return undefined;
    }
}
export default Maturity;
